import { render } from "./AboutUs.vue?vue&type=template&id=4ba42bc1&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=4ba42bc1&scoped=true&lang=css"

import exportComponent from "D:\\Front-end\\Beetronix\\alradwan-frontend\\vue-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba42bc1"]])

export default __exports__